import React, { useState } from "react";
import { Link } from "react-router-dom";
import GlobalApiKeyManager from "./agentHub/components/GlobalApiKeyManager";
import Icon from "./ui/Icon";

export default function Settings() {
  const [showApiKeyManager, setShowApiKeyManager] = useState(false);
  return (
    <div className="ui-page settings-page">
      <div className="ui-page-heading">
        <span className="ui-eyebrow">MAKE YOURSELF AT HOME</span>
        <h1>Workspace settings</h1>
        <p>Your connections, your tools, and the way you work.</p>
      </div>
      <div className="settings-layout">
        <aside className="settings-summary">
          <span className="home-feature-icon home-feature-icon--green">
            <Icon name="settings" size={24} />
          </span>
          <h2>Connected to your workflow.</h2>
          <p>
            Add the services your agents need. You decide which tools to enable
            for each agent.
          </p>
          <Link className="ui-text-link" to="/agent-hub/create">
            Configure an agent <Icon name="arrow" size={17} />
          </Link>
        </aside>
        <div className="settings-sections">
          <section className="ui-panel settings-connection">
            <div className="settings-section-title">
              <Icon name="key" />
              <h2>API keys & connections</h2>
              <span className="ui-tag">This browser</span>
            </div>
            <p>
              Manage credentials for AI providers, search, and email services used by your
              agents.
            </p>
            <button
              className="ui-button ui-button--primary"
              onClick={() => setShowApiKeyManager(true)}
            >
              Manage API keys <Icon name="arrow" size={17} />
            </button>
          </section>
          <section className="ui-panel">
            <div className="settings-section-title">
              <Icon name="globe" />
              <h2>Available services</h2>
            </div>
            <div className="settings-service-row">
              <div>
                <strong>Search the web</strong>
                <p>Brave Search and SerpAPI</p>
              </div>
              <span className="ui-tag">Search</span>
            </div>
            <div className="settings-service-row">
              <div>
                <strong>Send an update</strong>
                <p>SendGrid, Mailgun, and EmailJS</p>
              </div>
              <span className="ui-tag">Email</span>
            </div>
            <div className="settings-service-row">
              <div>
                <strong>Choose your AI model</strong>
                <p>
                  Connect OpenAI or DeepSeek above, then choose a model in your agent’s configuration.
                </p>
              </div>
              <Link
                className="ui-icon-button"
                aria-label="Open Agent Hub to configure models"
                to="/agent-hub"
              >
                <Icon name="arrowUpRight" />
              </Link>
            </div>
          </section>
          <section className="settings-privacy">
            <Icon name="shield" />
            <div>
              <h2>A note on your data</h2>
              <p>
                Keys are saved in this browser. When a tool runs, its
                credentials may be sent to the service through the backend
                proxy. Only add keys on a device you trust.
              </p>
            </div>
          </section>
        </div>
      </div>
      {showApiKeyManager && (
        <GlobalApiKeyManager onClose={() => setShowApiKeyManager(false)} />
      )}
    </div>
  );
}
